<ng-container [formGroup]="formGroup">
  <nz-row [nzGutter]="[24, 24]">
    <nz-col nzSpan="12">
      <div class="page-content-section " style="height: 390px;">
        <fieldset>
          <legend>{{'Attribute Information'  | translate}}</legend>
          <nz-form-item *ngIf="mode === 'edit'">
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Code">
              {{'Id' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the attribute set id.'| translate">
              <input nz-input formControlName="Id" id="Id" readonly />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="IsUnique">
              {{'Related Entity Type' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please select the realted entity type' | translate">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Please select the realted entity type' | translate"
                formControlName="RelatedObjectType" id="RelatedObjectType">
                <ng-container *ngFor="let option of entitiesValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Name">
              {{'Name' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the attribute name.' | translate">
              <input nz-input formControlName="Name" id="Name" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Label">
              {{'Label' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the attribute label.' | translate">
              <input nz-input formControlName="Label" id="Label" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Scope">
              {{'Scope' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Scope' | translate">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select an Scope' | translate" formControlName="Scope" id="Scope">
                <ng-container *ngFor="let option of scopeValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Scope">
              {{'Has unit of measurement' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Scope' | translate">
              <nz-select [nzAllowClear]="true" [ngModel]="hasUomAttribute" [ngModelOptions]="{ standalone: true }" (ngModelChange)="
                  this.hasUomAttribute = $event; hasUomChanged.emit($event)
                ">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </fieldset>
        <input type="hidden" formControlName="ParentAttributeId" #parentAttributeId />
        <a *ngIf="
            parentAttributeId != null &&
            parentAttributeId.value != null &&
            parentAttributeId.value != ''
          " [routerLink]="['/settings/attribute/edit/', parentAttributeId.value]">{{'Go to parent attribute' | translate}}</a>
      </div>
    </nz-col>
    <nz-col nzSpan="12">
      <div class="page-content-section scrollable-container">
        <fieldset>
          <legend class="sticky-legend">{{'Additional Details' | translate}}</legend>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="Visible">
              {{'Visible' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Visible' | translate">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select an Visible' | translate" formControlName="Visible"
                id="Visible">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="IsUnique">
              {{'Is Unique' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Is Unique' | translate">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select an Is Unique' | translate" formControlName="IsUnique"
                id="IsUnique">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="IsRequired">
              {{'Is Required' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please Choose a value' | translate">
              <nz-select nzShowSearch nzAllowClear formControlName="IsRequired" id="IsRequired">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" nzRequired [nzNoColon]="true" nzFor="AddToCol">
              {{'Visible In Grid' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Add To Col' | translate">
              <nz-select nzShowSearch nzAllowClear [nzPlaceHolder]="'Select an Add To Col' | translate" formControlName="AddToCol"
                id="AddToCol">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="UseAigeneration">
              {{'Use AI Text Generation' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Visible' | translate">
              <nz-select [nzAllowClear]="true" nzShowSearch formControlName="UseAigeneration" id="UseAigeneration">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="VisibleInCatalogPages">
              {{'Visible In Catalog Pages' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value' | translate">
              <nz-select  [nzAllowClear]="true" nzShowSearch formControlName="VisibleInCatalogPages" id="VisibleInCatalogPages">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="UseInLayeredNavigation">
              {{'Use in layered navigation' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value' | translate">
              <nz-select [nzAllowClear]="true" nzShowSearch formControlName="UseInLayeredNavigation" id="UseInLayeredNavigation">
                <ng-container *ngFor="let option of useLayeredNavOptions">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>


          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="UseInSearch">
              {{'Use in search' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value' | translate">
              <nz-select [nzAllowClear]="true"  nzShowSearch formControlName="UseInSearch" id="UseInSearch">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>



          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="UsedInProductListing">
              {{'Used in product listing' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value' | translate">
              <nz-select [nzAllowClear]="true" nzShowSearch formControlName="UsedInProductListing" id="UsedInProductListing">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="UsedForSortingInProductListing">
              {{'Used for sorting in product listing' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value' | translate">
              <nz-select  [nzAllowClear]="true" nzShowSearch formControlName="UsedForSortingInProductListing" id="UsedForSortingInProductListing">
                <ng-container *ngFor="let option of yesNoValues">
                  <nz-option [nzValue]="option.Code" [nzLabel]="option.Name">
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item> 
          
          
          <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="Position">
              {{'Position' | translate}}
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the Position' | translate">
              <nz-input-number 
                formControlName="Position" 
                id="Position" 
                [nzStep]="1" 
                [nzSize]="'default'"
                style="width: 100%;"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>

          <!-- <nz-form-item>
            <nz-form-label [nzSm]="24" [nzMd]="12" [nzNoColon]="true" nzFor="PositionInConfigurableAttribute">
              PosInConfigAttr
            </nz-form-label>
            <nz-form-control [nzSm]="24" [nzMd]="12" nzErrorTip="Please insert the value">
              <nz-input-number 
                formControlName="PositionInConfigurableAttribute" 
                id="PositionInConfigurableAttribute" 
                [nzStep]="1" 
                [nzSize]="'default'"
                style="width: 100%;"
              ></nz-input-number>
            </nz-form-control>
          </nz-form-item>  -->
          
          
        
        </fieldset>
      </div>
    </nz-col>
  </nz-row>
  <nz-row *ngIf="ShowAiQuestionSection">
    <nz-col nzSpan="24">
      <div class="page-content-section" style="padding: 10px">
        <fieldset>
          <legend>{{'AI Text Generation Question' | translate}}</legend>

          <textarea nz-input nzAutosize formControlName="AigenerationQuestion" id="AigenerationQuestion" cols="30"
            rows="4"></textarea>
        </fieldset>
        <div class="ai-hint-paragraph">
          <p>{{'you can use these keywords in the question:' | translate}}</p>
          <ul>
            <li>
              {{ "{#name}" }}: {{'will be replaced with the name of the object
              where the attribute exist,ex: product name, category name' | translate}}
            </li>
            <li>
              {{ "{#sku}" }}: {{'will be replaced with the sku of the product where
              the attribute is getting value,' | translate}}
              <p>
                <u style="color: red">{{'note' | translate}}</u>: {{'this will work only in product' | translate}}
              </p>
            </li>
            <li>
              {{ "{#attribute:attributeCode}" }}: {{'will be replaced with the
              value of the attribute specified using the attribute code' | translate}}
              <p>
                <u style="color: red">{{'note' | translate}}</u> please replace (attributeCode)
                {{'with the attribute code you need to get i\'s value'| translate}}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </nz-col>
  </nz-row>
</ng-container>
